import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import {
  type MutationState,
  useMutation,
} from 'src/core/api/hooks/useMutation';

type Payload = {
  restrict_domain?: string;
};

export const useCreateInviteLinkMutation = (): MutationState<Payload> => {
  const companyId = useCompanyId();

  return useMutation<Payload>({
    request: {
      type: 'rest',
      method: 'post',
      target: 'companyAPI',
      endpoint: '/invite-links',
    },
    options: {
      onSuccess: ({ client }) => {
        client.invalidateQueries(['inviteLink', companyId]);
      },
    },
  });
};
